import {
  //
  ADD_HOME_GROUP_ADMIN,
  ADD_HOME_GROUP_ADMIN_FAILURE,
  ADD_HOME_GROUP_ADMIN_SUCCESS,
  //
  DELETE_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN_FAILURE,
  DELETE_HOME_GROUP_ADMIN_SUCCESS,
  //
  EDIT_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN_FAILURE,
  EDIT_HOME_GROUP_ADMIN_SUCCESS,
  //
  FETCH_HOME_GROUP_ADMINS,
  FETCH_HOME_GROUP_ADMINS_FAILURE,
  FETCH_HOME_GROUP_ADMINS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_ADMIN_ADD_MODAL,
  CLOSE_ADMIN_ADD_MODAL,
  //
  OPEN_ADMIN_EDIT_MODAL,
  CLOSE_ADMIN_EDIT_MODAL,
  //
  INVITE_ADMIN,
  INVITE_ADMIN_SUCCESS,
  INVITE_ADMIN_FAILURE,
  //
  GET_USER_LIST,
  GET_USER_LIST_SUCCESS,
  GET_USER_LIST_FAILURE,
} from "./constants";

// List
export const fetchHomeGroupAdmins = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS,
  payload,
});
export const fetchHomeGroupAdminsSuccess = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS_SUCCESS,
  payload,
});
export const fetchHomeGroupAdminsFailure = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addHomeGroupAdmin = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN,
  payload,
});
export const addHomeGroupAdminSuccess = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const addHomeGroupAdminFailure = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
// EDIT
export const editHomeGroupAdmin = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN,
  payload,
});
export const editHomeGroupAdminSuccess = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const editHomeGroupAdminFailure = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
// DELETE
export const deleteHomeGroupAdmin = (payload, onDeleteSuccess) => ({
  type: DELETE_HOME_GROUP_ADMIN,
  payload,
  onDeleteSuccess,
});
export const deleteHomeGroupAdminSuccess = (payload) => ({
  type: DELETE_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const deleteHomeGroupAdminFailure = (payload) => ({
  type: DELETE_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
//
export const openAdminAddModal = (payload) => ({
  type: OPEN_ADMIN_ADD_MODAL,
  payload,
});
export const closeAdminAddModal = (payload) => ({
  type: CLOSE_ADMIN_ADD_MODAL,
  payload,
});
//
export const openAdminEditModal = (payload) => ({
  type: OPEN_ADMIN_EDIT_MODAL,
  payload,
});
export const closeAdminEditModal = (payload) => ({
  type: CLOSE_ADMIN_EDIT_MODAL,
  payload,
});
//
export const inviteAdmin = (payload) => ({
  type: INVITE_ADMIN,
  payload,
});
export const inviteAdminSuccess = (payload) => ({
  type: INVITE_ADMIN_SUCCESS,
  payload,
});
export const inviteAdminFailure = (payload) => ({
  type: INVITE_ADMIN_FAILURE,
  payload,
});
//
export const getUserList = (payload) => ({
  type: GET_USER_LIST,
  payload,
});
export const getUserListSuccess = (payload) => ({
  type: GET_USER_LIST_SUCCESS,
  payload,
});
export const getUserListFailure = (payload) => ({
  type: GET_USER_LIST_FAILURE,
  payload,
});
